// extracted by mini-css-extract-plugin
module.exports = {"sliderI":"SliderI_sliderI__5WMIK"};